export const emotionList = [
  {
    emotionId: 1,
    emotionImage: process.env.PUBLIC_URL + `/assets/icons/emotion-1.svg`,
    emotionDescription: "lost",
  },
  {
    emotionId: 2,
    emotionImage: process.env.PUBLIC_URL + `/assets/icons/emotion-2.svg`,
    emotionDescription: "draw",
  },
  {
    emotionId: 3,
    emotionImage: process.env.PUBLIC_URL + `/assets/icons/emotion-3.svg`,
    emotionDescription: "win",
  },
];
